import React from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Amplify } from 'aws-amplify';
import AuthService from '../../../services/cognito/auth';
import messages from './messages';
import validator from './validator';
import styles from './ResetPasswordForm.module.scss';
import InputText from '../../common/InputText';
import {
  setIsResendEmailSubmitted,
} from '../../../slices/accounts';

import awsconfig from '../../../aws-exports';
import PrimaryButton from '../../common/PrimaryButton';

const ResetPasswordForm = ({
  setAPIError,
  customerEmail = '',
}) => {
  const { formatMessage } = useIntl();
  Amplify.configure(awsconfig);
  const dispatch = useDispatch();
  const apiErrorCodes = {
    CodeMismatchException: formatMessage(messages.verificationCodeMismatchException),
    ExpiredCodeException: formatMessage(messages.verificationCodeExpiredCodeException),
    LimitExceeded: formatMessage(messages.verificationCodeResetLimitExceeded),
  };

  const onResetPassword = async ({ email }) => {
    try {
      await AuthService.resetPassword({ email });
      dispatch(setIsResendEmailSubmitted({ isResendEmailSubmitted: email }));
    } catch (error) {
      const errorMessageCode = Object.keys(apiErrorCodes).find((errorCode) =>
        error.name.includes(errorCode) ?? errorCode);
      setAPIError(apiErrorCodes[errorMessageCode] || error);
    }
  };

  const {
    values, handleSubmit, handleChange, handleBlur, errors,
  } =
    useFormik({
      initialValues: {
        email: customerEmail,
      },
      onSubmit: onResetPassword,
      validate: (v) => validator(v, { formatMessage }),
    });
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={styles.loginInputField}>
          <InputText
            id="email"
            type="email"
            name="email"
            value={values.email}
            label={formatMessage(messages.emailLabel)}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMsg={errors.emailError}
            required
          />
        </div>
        <PrimaryButton
          type="submit"
          title={formatMessage(messages.resetPasswordButton)}
          dataTestId="reset_password_btn"
          onClick={() => {}}
        />
      </form>
    </>
  );
};

ResetPasswordForm.propTypes = {
  customerEmail: PropTypes.string,
  setAPIError: PropTypes.func.isRequired,
};

export default ResetPasswordForm;
